/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/list/list_styles';
//materials
import FancyRadio from 'material/fancyradio/fancyradio';
import RadioField from 'material/form/field/radio/radio';
import CheckboxField from 'material/form/field/checkbox/checkbox';
import GridSet from 'material/grid/gridset/gridset';


class List extends Component {

    singleItem = (item) => {
        return (typeof (item) === "string");
    }

    hasItems = () => { return (Array.isArray(this.props.items) && this.props.items.length > 0) };

    getListType = () => {
        switch (this.props.type) {
            case 'checkbox':
                return this.renderList(CheckboxField);
            case 'fancy-radio':
                return this.renderList(FancyRadio);
            case 'radio':
            default:
                return this.renderList(RadioField);
        }
    }

    renderList = (type) => (this.props.items.map((item, index) => {
            const { value, text } = item;
            const currentElement = React.createElement(type, {
                key: index,
                name: value,
                isList: true,
                disabled: this.props.disabled ? (this.singleItem(this.props.disabled) ? (this.props.disabled === value) : this.props.disabled.includes(value)) : false,
                checked: this.props.selected ? (this.singleItem(this.props.selected) ? (this.props.selected === value) : this.props.selected.includes(value)) : false,
                handleChange: () => this.props.handleChange(value)
            });
            return (type === FancyRadio) ? React.cloneElement(currentElement, { title: text }) :
                <label key={index} className={`list-item`}> 
                    {currentElement}
                    <div className={`option-text`}>
                        {text}
                    </div>
                </label>
        })
    )

    render() {
        return (
            <div className={`list ${this.props.classes.list}`}>
                {this.hasItems() ?
                    <GridSet direction={'vertical'}>
                        {this.getListType()}
                    </GridSet> : null}
            </div>
        );
    }
}

export default injectSheet(styles)(List);